import React, { useContext } from "react";
import LoginSignUpModal from "../AgentWebsite/Login/loginSignUpModal";
import { WebContext } from "../../Utility";

const RedirectionLogin = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const callBackurl = urlSearchParams.get("callback_url");

  const { isLoggedIn } = useContext(WebContext);


  if (!callBackurl) return null;

  if (!window.location.search) return null;

  if (isLoggedIn) {
    if (callBackurl) {
      const decodedUrl = decodeURIComponent(callBackurl);
      window.location.href = decodedUrl;
    }
    return null;
  }

  return (
    <LoginSignUpModal
      onVerificationSuccess={() => {
        const decodedUrl = decodeURIComponent(callBackurl);
        window.location.href = decodedUrl;
      }}
    />
  );
};

export default RedirectionLogin;
